import { ChevronDown, Upload,ChevronUp,CircleX} from 'lucide-react';
import React, { useState, useEffect,useRef} from 'react';
import { AuthData } from "../../auth/AuthWrapper"
import axios from 'axios';
import { useParams,useNavigate } from "react-router-dom";
import {RefreshCw,CircleCheckBig,ClipboardPen,Circle,WandSparkles,FileCode, Trash2,FileText, LayoutGrid, ClipboardList, File, Settings,Menu,FileCheck, FileClock,CircleChevronRight,CircleChevronLeft,UserCheck,User,Pencil, Plus} from 'lucide-react';
import { NavLink } from 'react-router-dom';
import { API_SERVER_URL } from "../../utils/config_ip_details";
import { getUsername,getInitials } from "../../utils/common_functions";
import { apiCall } from "../../utils/server_utils";
import { API_SUCCESS_RESPONSE_CODE,API_SUCCESS_RESPONSE_CREATED_CODE } from "../../utils/config_mapping";
import PageLoader from '../common/pageloader';
import $ from "jquery";
import {trackError} from "../../utils/error_tracker"
import { Toast } from '../common/toast';
import { MoreVertical, Eye, Download, Share2, Star, Trash,LayoutPanelTop,ChevronRight } from "lucide-react";
import clsx from "clsx";
import { Check, Edit2 } from "lucide-react";
import Select from 'react-select';
import  {Requirements} from "./requriement"
import Sidebar from '../structure/sidebar'; 


const specsData = [
  { title: "Use AES-256 encryption for all bucket contents", percentage: 92, status: "Pending" },
  { title: "Implement server-side encryption with managed keys", percentage: 87, status: "Pending" },
  { title: "Enable encryption for data at rest and in transit", percentage: 95, status: "Approved" }
];




export default function DeleteConfirmationDialog({ isOpen, onClose, onConfirm,templateName }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white rounded-2xl shadow-xl p-6 w-296">
        <h2 className="text-xl font-semibold mb-4">Delete</h2>
        <p className="text-gray-600 mb-6">Are you sure you want to delete {templateName} item?</p>
        <div className="flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100 transition"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 rounded-lg bg-gray-600 text-white hover:bg-gray-700 transition"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
}




export const SpecificationCard = (requirement, specs) => {

  return (
    <div className="bg-white p-6 rounded-lg shadow space-y-4">
      {/* Requirement Title */}
      <div>
        <p className="font-semibold text-sm text-gray-600">Requirement:</p>
        <p className="text-gray-900 text-base font-medium mb-2">
          {requirement}
        </p>
      </div>

      {/* Tabs (Static) */}
      <div className="flex gap-4 text-sm font-medium border rounded-md overflow-hidden">
        <button className="bg-gray-100 px-4 py-2">
          {/* All Specifications <span className="ml-1 text-gray-500">{specs.length}</span> */}
        </button>
        <button className="px-4 py-2 text-green-600">
          {/* Approved <span className="ml-1">{specs.filter(s => s.status === "Approved").length}</span> */}
        </button>
        <button className="px-4 py-2 text-yellow-600">
          {/* Pending Approval <span className="ml-1">{specs.filter(s => s.status === "Pending").length}</span> */}
        </button>
      </div>

      {/* Specifications List */}
      <div className="space-y-4">
        {specs.map((spec, index) => (
          <div
            key={index}
            className="flex items-center justify-between bg-white border rounded p-3"
          >
            <div className="w-full">
              <p className="text-sm font-medium text-gray-800 mb-1">
                {spec.title}
              </p>
              <div className="w-full bg-gray-200 rounded-full h-2.5">
                <div
                  className={`${getProgressColor(spec.percentage)} h-2.5 rounded-full`}
                  style={{ width: `${spec.percentage}%` }}
                ></div>
              </div>
            </div>
            <div className="flex items-center gap-2 ml-4">
              <span
                className={`text-xs font-medium px-2 py-1 rounded ${
                  spec.status === "Approved"
                    ? "bg-green-100 text-green-800"
                    : "bg-yellow-100 text-yellow-800"
                }`}
              >
                {spec.status}
              </span>
              <button className="bg-gray-100 rounded-full p-1 border">
                <Check className="h-4 w-4 text-gray-700" />
              </button>
              <button className="bg-gray-100 rounded-full p-1 border">
                <Edit2 className="h-4 w-4 text-gray-700" />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

// Utility to calculate average score
const calculateAverage = (specs) => {
  if (!specs.length) return 0;
  const total = specs.reduce((sum, s) => sum + s.percentage, 0);
  return Math.round(total / specs.length);
};


// Utility to get bar color
const getProgressColor = (percent) => {
  if (percent >= 90) return "bg-green-500";
  if (percent >= 80) return "bg-blue-500";
  return "bg-gray-500";
};




const data = [
  { name: 'Jan', documents: 4, techSpecs: 3 },
  { name: 'Feb', documents: 7, techSpecs: 5 },
  { name: 'Mar', documents: 9, techSpecs: 7 },
  { name: 'Apr', documents: 12, techSpecs: 9 },
  { name: 'May', documents: 15, techSpecs: 11 },
  { name: 'Jun', documents: 18, techSpecs: 14 },
];


const initialRequirements = [
    {
      id: 'REQ-001',
      text: 'The system shall support automated scaling of compute resources based on load.',
      section: 'Performance',
    },
    {
      id: 'REQ-002',
      text: 'All data at rest must be encrypted using AES-256 encryption.',
      section: 'Security',
    },
    {
      id: 'REQ-003',
      text: 'The system must maintain 99.99% uptime for availability.',
      section: 'Availability',
    },
  ];


  // const filters = ["All Documents", "Requirements", "Best Practices", "Templates", "Tech Specs", "Starred"];

  const filters = ["All Requirements",  "Starred"];

  const innerfilters = ["View Landscapes",  "View Service Roles"];


const documents = [
  {
    id: 1,
    title: "Infrastructure Requirements v1.2",
    date: "2023-10-15",
    size: "2.4 MB",
    author: "John Smith",
    tags: ["Requirements", "AWS", "Cloud", "Security"],
    type: "Active",
    starred: true,
    iconColor: "text-purple-500",
  },
  {
    id: 2,
    title: "GxP Compliance Guidelines",
    date: "2023-09-05",
    size: "1.7 MB",
    author: "Maria Rodriguez",
    tags: ["Best Practices", "GxP", "Validation", "Compliance"],
    type: "Active",
    starred: false,
    iconColor: "text-green-500",
  },
  {
    id: 3,
    title: "Technical Specification Template",
    date: "2023-08-22",
    size: "756 KB",
    author: "David Chen",
    tags: ["Template", "Template", "Specification"],
    type: "Active",
    starred: true,
    iconColor: "text-yellow-500",
  },
];


  // 🧩 Reusable NavItem component with hover tooltip
const NavItem = ({ to, icon, label, isSidebarOpen }) => (
  <NavLink
    to={to}
    className={({ isActive }) =>
      `group relative flex items-center p-2 rounded hover:bg-gray-700 transition-all duration-200 ${
        isSidebarOpen ? "justify-start" : "justify-center"
      } ${isActive ? "bg-white text-black font-medium" : "text-white"}`
    }
  >
    {icon}
    {isSidebarOpen ? (
      <span className="ml-2">{label}</span>
    ) : (
      <span className="absolute left-full ml-2 whitespace-nowrap bg-gray-800 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-50 shadow-lg">
        {label}
      </span>
    )}
  </NavLink>
);



export const TechSpec = () => {
  //const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
    // Initialize from localStorage, default to false
    const saved = localStorage.getItem('isSidebarOpen');
    return saved === 'true';
  });

  // Update localStorage whenever isSidebarOpen changes
  useEffect(() => {
    localStorage.setItem('isSidebarOpen', isSidebarOpen);
  }, [isSidebarOpen]);


  const { user, isLoggedIn, logout } = AuthData();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]); // API data for documents
  const [templateData, setTemplateData] = useState([]); // API data for documents

  const [dataTechSpec, setDataTechSpec] = useState([]); // API data for documents
  const [secificationExport, setSecificationExport] = useState(false); // API data for documents
  const [complianceExport, setComplianceExport] = useState(false); // API data for documents

  const [showUpload, setShowUpload] = useState(false);
  const navigate = useNavigate();
  const [activeFilter, setActiveFilter] = useState("All Requirements");
  const [activeInnerFilter, setInnerActiveFilter] = useState("View Landscapes");
  const [openDropdown, setOpenDropdown] = useState(null);
  const dropdownRef = useRef(null);
  let {documentid,documentname} = useParams(); // Extract the `id` parameter from the URL

  const [specEdits, setSpecEdits] = useState({});
  const [radioSelections, setRadioSelections] = useState({});

  const [enabled, setEnabled] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleteModalOpen, setDeleteIsModalOpen] = useState(false);
  const [mapTemplateJson, setMapTemplateJson] = useState(false);
  const [stepMapTemplate, setStepMapTemplate] = useState(2);
  const [selectedTemplateId, setSelectedTemplateId] = useState("");


  // useEffect(() => {

  //   if (documentid !== undefined && data.length > 0) {
  //     setSelectedDocIndex(0);
  //   }
  // }, [documentid, data]);

  
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenDropdown(null);  // Close dropdown if click is outside
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  
  useEffect(() => {
    const initialSelections = {};
    dataTechSpec.forEach((req) => {
      // console.log("------------------");
      // console.log(req.allSpecs)
      // console.log("------------------");
      if(req.allSpecs!==undefined){
      req.allSpecs.forEach((spec) => {
        if (spec.approved) {
          initialSelections[req.requirementId] = spec.specId;
        }
      });
    }
    });
    setSelectedOptions(initialSelections);
  }, [dataTechSpec]);



  
  
  const refresh = () => {
  fetchTechSpecDetails(sepcificationDocumentId)
  }

  const fetchTechSpecDetails = async (documentid) => {
    setLoading(true);
    try {
      const result = await apiCall("GET", `${API_SERVER_URL}tech-spec/document/`+documentid+"/");
      if (result.code === API_SUCCESS_RESPONSE_CODE) {
        setDataTechSpec(result.data.tech_specs);
        setSecificationExport(result.data.spec_export)
        setComplianceExport(result.data.compliance_export)
        setSelectedDocumentId(documentid)
        setLoading(false);
        if(documentid!==undefined){
          setSelectedDocIndex(0);
          const timer = setTimeout(() => {
            $("#list_view,#btn_uplod").addClass("d-none")
          }, 200);
        }
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching contracts", error);
    }
  };

  const [selectedOptions, setSelectedOptions] = useState({});

  const [selectedDocumentId, setSelectedDocumentId] = useState({});


  const saveMapTemlate = async () => {
  let postdata = {"document_id": mapTemplateJson.document_id,  "template_id" : selectedTemplateId }
  let apiUrl = API_SERVER_URL+ 'document/'+mapTemplateJson.document_id+"/template/"+selectedTemplateId+'/template-map/'
  let method = "POST"
  try {
      const result =  apiCall(method,apiUrl,postdata);
      setIsModalOpen(false);setSelected(""),setStepMapTemplate(2)
  } catch (error) {
    console.error("Error refreshing token:", error);
  }
  }

  const setSelectedOption = async (sepcid,id) => {
   // setLoading(true);

   setSelectedOptions((prev) => ({
    ...prev,
    [id]: sepcid
  }));


  console.log(dataTechSpec)

    try {
      const result = await apiCall("POST", `${API_SERVER_URL}tech-spec/approve/document/`+selectedDocumentId+`/requirement/`+id+`/tech-spec/`+sepcid+"/",{});
      if (result.code === API_SUCCESS_RESPONSE_CODE) {
        //setData(result.data);
        //fetchWidget(selectedDoc.document_id)
      }
    } catch (error) {
  // setLoading(false);
      console.error("Error fetching contracts", error);
    }
  };

  
  const createSpec = (id,title) => {
    setClickviewRequirement(false)
    setSelectedDocIndex(null)
    handleViewSpecifications(id,title)
    $("#list_view,#btn_uplod").removeClass("d-none")

  };


  const closeRequirement = () => {
    setClickviewRequirement(false)
    setSelectedDocIndex(null)
    $("#list_view,#btn_uplod").removeClass("d-none")
  };


  const backtolist = () => {
    closeRequirement()
  }
  


  const fetchWidget = async (documentid) => {
    setLoading(true);
    try {
      const result = await apiCall("GET", `${API_SERVER_URL}requirements/`);
      if (result.code === API_SUCCESS_RESPONSE_CODE) {
        setData(result.data);
        setLoading(false);
        //alert(documentid)

        if(documentid!==undefined){
          fetchTechSpecDetails(documentid)
          setSelectedDocIndex(0);
          const timer = setTimeout(() => {
            $("#list_view,#btn_uplod").addClass("d-none")
          }, 200);
        }
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching contracts", error);
    }
  };


  const fetchTemplate = async (documentid) => {
    setLoading(true);
    try {
      const result = await apiCall("GET", `${API_SERVER_URL}templates/`);
      if (result.code === API_SUCCESS_RESPONSE_CODE) {
        setTemplateData(result.data);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching contracts", error);
    }
  };

  
  useEffect(() => {
  
    fetchWidget(documentid);
    fetchTemplate()
          // ✅ Run this AFTER data is fetched
      //    if (documentid !== undefined && data.length > 0) {
        //    alert("!!!!!!")
    //        setSelectedDocIndex(0);
       //   }


  }, [documentid]);
  
      

  const documents = [
    {
      id: 1,
      name: "Document A",
      requirementsCount: 5,
      techSpec: "Tech Spec A",
    },
    {
      id: 2,
      name: "Document B",
      requirementsCount: 3,
      techSpec: null,
    }
  ];

  const fileInputRef = useRef(null);

  const handleClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (event) => {
    const files = event.target.files;
    if (files.length > 0) {
      // console.log('Selected files:', files);
      // handle the uploaded files here
    }
  };


  

  const [expandedDocId, setExpandedDocId] = useState(null);
  const [selectedDocIndex, setSelectedDocIndex] = useState(null);
  const [clickviewRequirement, setClickviewRequirement] = useState(false);


  const toggleAccordion = (docId) => {
    setExpandedDocId(prev => (prev === docId ? null : docId));
    };
    const toggleUpload = () => {
        setShowUpload(!showUpload);
        setFiles([])
      };

      

      const handleViewSpecifications = (index,title) => {
        $("#list_view,#btn_uplod").addClass("d-none")
        setClickviewRequirement(false)
        fetchTechSpecDetails(index)
        setShowUpload(false)
        setSepcificationDocumentName(title)
        setSepcificationDocumentId(index)
        setExpandedRows([])
        };


      const handleViewTemplate = (index) => {
        navigate("/infrastructure-context/list")

      } 

      const handleViewRequirements = (index,title) => {
        setSepcificationDocumentName(title)
        $("#list_view,#btn_uplod").addClass("d-none")
        setSelectedDocIndex(index);
        // fetchTechSpecDetails(index)
        setShowUpload(false)
        //setExpandedRows([])
        setClickviewRequirement(true)
        //clickviewRequirement, setClickviewRequirement
//        setSelectedDocIndex(index);

        };

      const closeDetailDocumentView = (index) => {
        $("#list_view,#btn_uplod").removeClass("d-none")
        setSelectedDocIndex(null);
        setClickviewRequirement(false)
      };

  const [sepcificationDocumentName,setSepcificationDocumentName] = useState('')    
  const [sepcificationDocumentId,setSepcificationDocumentId] = useState('')    

  const [requirements, setRequirements] = useState(initialRequirements);
  const [modalOpen, setModalOpen] = useState(false);
  const [editingRequirement, setEditingRequirement] = useState(null);

  const handleOpenAdd = () => {
    setEditingRequirement(null);
    setModalOpen(true);
  };



  
  const showTextArea = (id) => {
    $("#"+id).removeClass("d-none")
  }

  const closeTextArea = (id) => {
    $("#"+id).addClass("d-none")
  }

  


  // const saveTextArea = (id) => {
  //   $("#"+id).addClass("d-none")
  // }

  const handleEdit = (req) => {
    setEditingRequirement(req);
    setModalOpen(true);
  };


  const [text, setText] = useState('');
  const [savedText, setSavedText] = useState('');

  const handleSaveConfidence = () => {
    setSavedText(text);
    console.log('Saved:', text);
  };

  const handleCancel = () => {
    setText(savedText);
  };



  const handleSave =  async (req) => {
    if (editingRequirement) {
      // Edit
      setRequirements((prev) =>
        prev.map((r) => (r.id === editingRequirement.id ? req : r))
      );
    } else {

      let postdata =  {
        "document_id": selectedDoc.document_id,
        "requirement_id": req.id,
        "text": req.text,
        "section": req.section
      }

      let apiUrl = API_SERVER_URL+ 'requirements/'
          let method = "POST"
          try {
              const result = await apiCall(method,apiUrl,postdata);
              if(result!==undefined){
              if (result.code === API_SUCCESS_RESPONSE_CREATED_CODE) {
                fetchWidget();
              } else {
                trackError("The API response is invalid:<br/>URL:"+apiUrl+"<br/>Method:"+method+"<br>", JSON.stringify(result))
              }
              }
          } catch (error) {
            console.error("Error refreshing token:", error);
          }

      // Add
      //alert(1111);
      //setRequirements((prev) => [...prev, req]);
    }
    setModalOpen(false);
  };

  // alert(selectedDocIndex)

  let selectedDoc = selectedDocIndex!==null ? data.requirements_types.filter(
    (doc) => doc.document_id === selectedDocIndex
  ) : ""



  const [searchText, setSearchText] = useState('');
  const [selectedTypes, setSelectedTypes] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState([]);

  const [selected, setSelected] = useState('');

  const [isDialogOpen, setIsDialogOpen] = useState(false);


  let requirementTypes;
  let status;
  let  filteredRequirements;
  if(dataTechSpec!==""){
    
   requirementTypes = [
    ...new Set(dataTechSpec.map((req) => req.requirementType))
  ].map((type) => ({ value: type, label: type }));


  status = [{ value: "Approved", label: "Approved" },{ value: "Pending", label: "Pending" }]

  const lowerSearch = searchText.toLowerCase();


  filteredRequirements = dataTechSpec.filter((req) => {
    const selectedValues = selectedTypes.map((opt) => opt.value);

    const selectedStatusValues = selectedStatus.map((opt) => opt.value);

    const matchesType = selectedValues.length > 0 ? selectedValues.includes(req.requirementType) : true;

    const matchesStatus = selectedStatusValues.length > 0 ? selectedStatusValues.includes(req.techSpecApprovalStatus) : true;


    const matchesSearch =
    req.description?.toLowerCase().includes(lowerSearch) ||
    req.requirementId?.toLowerCase().includes(lowerSearch) ||
    req.serviceSpecId?.toLowerCase().includes(lowerSearch) ||
    req.reqId?.toLowerCase().includes(lowerSearch) ||
    req.requirementType?.toLowerCase().includes(lowerSearch) ||
    req.techSpecApprovalStatus?.toLowerCase().includes(lowerSearch);
    return matchesStatus && matchesType && matchesSearch;
  });
  
}


  //alert(JSON.stringify(selectedDoc))

  const [expandedRows, setExpandedRows] = useState([]);

  const [confirmDelete, setConfirmDelete] = useState({ show: false, requirement: null,document_id:""});




  const toggleRow = (id) => {
    setExpandedRows((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
    );
  };

  const handleCreateTechSpec = (id,name) => {
    navigate("/tech-spec/"+id+"/"+name)
  };

  const gotoTemplate = () => {
    navigate("/infrastructure-context")
  };

  const mapTemplate = (json) => {
    navigate("/infrastructure-context/"+json.document_id+"/"+json.title)
} 

  

  
const initialState = {
  document_type: null,
  documentFile: null,
}

  const [files, setFiles] = useState([]);


  const handleDrop = (event) => {
    event.preventDefault();
    const droppedFiles = Array.from(event.dataTransfer.files);
    if (droppedFiles[0]?.size > 20 * 1024 * 1024) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        documentFile: "File size must not exceed 20 MB.",
      }));
      return;
    }
    setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
    setFormData((prev) => ({ ...prev, documentFile: droppedFiles[0] }));
    setErrors((prevErrors) => ({ ...prevErrors, documentFile: "" }));
  };


  const handleFileSelect = (event) => {
  const selectedFiles = Array.from(event.target.files);
  const file = selectedFiles[0];
  if (file?.size > 20 * 1024 * 1024) {
    setErrors((prevErrors) => ({
      ...prevErrors,
      documentFile: "File size must not exceed 20 MB.",
    }));
    return;
  }
  setFiles((prevFiles) => [...prevFiles, ...selectedFiles]);
  setFormData((prev) => ({ ...prev, documentFile: file }));
  setErrors((prevErrors) => ({ ...prevErrors, documentFile: "" }));
};

const handleDragOver = (event) => {
  event.preventDefault();
};


const validateForm = () => {
  const newErrors = {};
  if (!formData.documentFile) newErrors.documentFile = "Document File is required.";
  setErrors(newErrors);
  return Object.keys(newErrors).length === 0;
};

const [formData, setFormData] = useState(initialState);
const [errors, setErrors] = useState({});
const [showToast, setShowToast] = useState(false);



const handleSubmit = (e) => {
    const logged_user_name = getUsername();
    e.preventDefault();
    if (!validateForm()) return;
    $(".page_pro_load").show();
    const timestamp = Date.now();  // Current timestamp in milliseconds
    const randomDigits = Math.floor(Math.random() * 1000); // Generate 3 random digits (0-999)
    const uniqueId = "doc_"+parseInt(`${timestamp}${randomDigits}`.substr(0, 12)); // Concatenate and ensure 12 digits
    const formDataapi = new FormData();
    formDataapi.append('file',formData.documentFile);
    //formDataapi.append('document_type',formData.document_type.value);
    formDataapi.append('document_type',"test");
    formDataapi.append("username",logged_user_name);
    saveDocument(formDataapi)
  };


  
      const handleDelete = async () => {

       // document/:document_id/delete/

      //  console.log(mapTemplateJson.document_id);
      //  return;

      //   let dataId = confirmDelete.document_id
      //   let req_id = confirmDelete.requirement.req_id
      //   // const dataId = event.target.getAttribute('data-id');
        //if(dataId){
          let apiUrl = API_SERVER_URL+ 'document/'+mapTemplateJson.document_id+'/delete/';
          let method = "POST"
          try {
              const result = await apiCall(method,apiUrl);
              if(result!==undefined){
              if (result.code === API_SUCCESS_RESPONSE_CODE) {
               // setConfirmDelete({ show: false, requirement: null,document_id:"" })
               setDeleteIsModalOpen(false); setOpenDropdown(null);setMapTemplateJson(null)
                fetchWidget();
              } else {
                trackError("The API response is invalid:<br/>URL:"+apiUrl+"<br/>Method:"+method+"<br>", JSON.stringify(result))
              }
              }
          } catch (error) {
            console.error("Error refreshing token:", error);
          }
        
      };


  const exportfile = async (data) => {
   // setLoading(true);
    try {
      window.open(`${API_SERVER_URL}document/`+selectedDocumentId+`/export/`, '_blank');
      // const result = await apiCall("GET", `${API_SERVER_URL}document/`+selectedDocumentId+`/export/`);
      // if (result.code === API_SUCCESS_RESPONSE_CODE) {
      //  // setData(result.data);
      //   setLoading(false);
      //   window.open(result.data.file_url, '_blank');
      // }
    } catch (error) {
     // setLoading(false);
      console.error("Error fetching contracts", error);
    }


  // document/:document_id/export/
  }    

  const saveDocument = async (data) => {

    $("#uploaderror").html(""); // Clear previous error
    let authToken = localStorage.getItem("jsondata");
    if (authToken) {
      const jsonData = JSON.parse(authToken);
      authToken = jsonData.accessToken || "";
    }
    $("#process-loader").removeClass("d-none"); // Show loader
    try {
      const response = await axios.post(API_SERVER_URL + "document/", data, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + authToken,
        },
      });
      if(response.data.code === API_SUCCESS_RESPONSE_CREATED_CODE) {



        //    navigate("/infrastructure-context/"+json.document_id+"/"+json.title)

        toggleUpload()
        setFiles([])
        setShowToast(true)
        $("#process-loader").addClass("d-none");
        setLoading(true); // Stop loading spinner
        setTimeout(() => {
        fetchWidget();
          setIsModalOpen(true); setOpenDropdown(null);setMapTemplateJson({document_id:response.data.data._id,title:response.data.data.fileName})
        }, 500);
      } else {
        console.log("API Error Data:", response.data); // Debugging API response
        $("#process-loader").addClass("d-none");
        if (
          response.data.data &&
          response.data.data.error &&
          response.data.data.error.message
        ) {
          $("#uploaderror").html(response.data.data.error.message);
        } else {
          $("#uploaderror").html("An unexpected error occurred.");
        }
      }
    } catch (error) {
      console.error("Error uploading the file:", error);
      $("#process-loader").addClass("d-none");
      $("#uploaderror").html(
        `<div class="alert alert-danger" role="alert">
  `+ error.response?.data?.error.message || "An unexpected error occurred."+`
</div>`
      );
    }
  };

    return (
    <div className="flex h-screen">
      {/* Sidebar */}
      <Sidebar logout={logout} isSidebarOpen={isSidebarOpen} />

      {/* Main Content */}
      <div className={`flex-1 flex flex-col transition-all duration-300 ${isSidebarOpen ? 'ml-64' : 'ml-24'}`}>
      <button
  className="absolute ml-[-10px] top-4  flex items-center justify-center rounded-full text-white bg-blue-500 hover:bg-blue-600 z-50"
  onClick={() => setIsSidebarOpen(!isSidebarOpen)}
>
  {isSidebarOpen ? (
    <CircleChevronLeft className="w-5 h-5" />
  ) : (
    <CircleChevronRight className="w-5 h-5" />
  )}
</button>
  <header className="flex items-center justify-between p-4 bg-white shadow md:pl-6">
    
 
    <button
       className="md:hidden p-2 rounded text-gray-700 hover:bg-gray-200 -ml-5"
      onClick={() => setIsSidebarOpen(!isSidebarOpen)}
    >
      <Menu className="w-6 h-6" size={16} />
      </button>

    {/* Flex container for title and buttons */}
    <div className="flex flex-col w-full md:flex-row md:items-center md:justify-between">
      <div>
        <h1 className="text-2xl font-bold">Platform Service Specifications</h1>
        <p className="text-gray-600">Manage and track Specifications across documents</p>
      </div>

<div className="flex gap-3 mt-4 md:mt-0">
  <button
  id="btn_uplod"
  onClick={toggleUpload}
  className="mr-12 group relative flex items-center px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
>
  <Upload className="h-4 w-4" />
  {/* Tooltip BELOW the button */}
  <span className="absolute top-full mt-2 left-1/2 -translate-x-1/2 whitespace-nowrap bg-gray-800 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-50 shadow-md">
  Upload Requirements
  </span>
</button>

  {selectedDoc && clickviewRequirement === false && (
    <>
      {/* Specification Export Button */}
      <div className="relative group">
        <button
         onClick={() => {
          if (secificationExport === true) {
            exportfile()
          }
        }}
          className="flex items-center px-4 py-2 border rounded hover:bg-gray-50"
        >
          <FileText className="mr-2 h-4 w-4" />
          Export
        </button>
        {!secificationExport && (
          <span className="absolute top-full mt-2 left-1/2 -translate-x-1/2 whitespace-nowrap bg-gray-800 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-50 shadow-md">
            Please wait until the process completes.
          </span>
        )}
      </div>

      {/* Compliance Report Button */}
      <div className="relative group">
        <button
          onClick={() => {
            if (complianceExport === true) {
              window.open(
                `${API_SERVER_URL}document/${selectedDocumentId}/compliance-report/`,
                '_blank'
              );
            }
          }}
          className="flex items-center px-4 py-2 border rounded hover:bg-gray-50"
        >
          <FileText className="mr-2 h-4 w-4" />
          Generate GxP Compliance Report
        </button>
        {!complianceExport && (
          <span className="absolute top-full mt-2 left-1/2 -translate-x-1/2 whitespace-nowrap bg-gray-800 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-50 shadow-md">
            Please wait until the process completes.
          </span>
        )}
      </div>
    </>
  )}
</div>


    </div>
  </header>
        <main className="flex-1 p-6 bg-gray-100 overflow-y-auto">

        {showToast && (
       <Toast
       message="Success"
       subMessage="Requriment Successfully Uploaded!"
       type="success"
       duration={5000}
     />
      )}

{showUpload && (
     <form onSubmit={handleSubmit}>
      <div className="mb-6 border border-blue-200 bg-blue-50/50 rounded-xl shadow" 
                            onDrop={handleDrop}
                            onDragOver={handleDragOver}
      
      >
        <div className="p-4 border-b">
          <h2 className="text-lg font-semibold">Upload New Requirement</h2>
          <p className="text-sm text-gray-600">
            Supported formats: PDF, DOCX, XLSX, TXT, MD, CSV
          </p>
        </div>
        <div className="p-4">
          <div
            className="border-2 border-dashed border-blue-300 rounded-md p-6 text-center cursor-pointer hover:bg-blue-100 transition"
            onClick={handleClick}
          >
            <div className="flex justify-center">
              <div className="p-3 rounded-full bg-blue-100 text-blue-800">
                <Upload size={24} />
              </div>
            </div>
            <p className="font-medium text-blue-600">Upload Requirement</p>
            <p className="text-sm text-gray-500">Drag and drop your requirement here</p>
            <p className="mt-2 text-xs text-gray-400">
              Accepted: .docx, .pdf, .xlsx, .txt, .md, .csv | Max Size: 20MB
            </p>
            <input
              ref={fileInputRef}
              type="file"
              id="fileInput"
              accept=".docx,.pdf,.xlsx,.txt,.md,.csv"
              className="hidden"
              onChange={handleFileSelect}
            />

               <ul style={{ marginTop: "20px",wordBreak:"break-all" }}>
                                {files.map((file, index) => (
                                <span>{file.name}<br/></span> 
                                ))}
                              </ul>
                            <div id="uploaderror"></div>


          </div>
          <br/>
          <div className="flex justify-end">
          {/* <button onClick={handleSubmit} type="submit" className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-600">
                    Save
               </button> */}

<div id="process-loader" className='d-none pt-[10px] pr-[11px]'><div class="flex items-center space-x-2 text-sm text-gray-600">
  <svg class="w-5 h-5 animate-spin text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4l5-5-5-5v4a10 10 0 00-10 10h4z"></path>
  </svg>
  <span>Uploading file...</span>
</div></div>



<button 
  onClick={toggleUpload}
  type="button"
  className={`px-4 py-2 rounded text-white transition-colors duration-200 bg-blue-600 hover:bg-blue-700`}
>
  Cancel
</button>
&nbsp;&nbsp;&nbsp;

<button 
  disabled={files.length === 0}
  onClick={handleSubmit}
  type="submit"
  className={`px-4 py-2 rounded text-white transition-colors duration-200 
    ${files.length === 0 
      ? 'bg-gray-400 cursor-not-allowed' 
      : 'bg-blue-600 hover:bg-blue-700'}`}

>
  Save
</button>

               </div>
        </div>
      </div>

    

      </form>
      )
}
          {/* Document Activity Chart */}
          {loading ? (
                           <PageLoader />
                      ) :
<div class="">
{selectedDoc!=="" && clickviewRequirement && (
    <>
    <div className="flex justify-between items-center border-b p-3  text-sm">
       {/* Left section */}
       <div className="flex items-center space-x-4">
         <div className="flex items-center space-x-1 text-blue-600 cursor-pointer" onClick={backtolist}>
           <svg className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
             <path strokeLinecap="round" strokeLinejoin="round" d="M10 19l-7-7 7-7" />
           </svg>
           <span className="font-medium">Back to Manage Specifications</span>
         </div>
       </div>
     </div>  
<Requirements 
  selectedDocprops={selectedDoc}
  closeRequirement={closeRequirement}
  createSpec={createSpec}
  selectedDocIndexprops={selectedDocIndex}
 />
 </>
 )}
 
{ clickviewRequirement === false &&(
<div className={selectedDoc!=="" ? "p-6 d-none" : "p-6"  } id="list_view" >





<DeleteConfirmationDialog
        isOpen={isDeleteModalOpen}
       // onClose={() => {setIsModalOpen(false);setSelected(""),setStepMapTemplate(2)}}
        onClose={() => {setDeleteIsModalOpen(false); setOpenDropdown(null);setMapTemplateJson(null)}}
        onConfirm={handleDelete}
        templateName={mapTemplateJson!==null ? mapTemplateJson.title : "this"}
      />

      {/* Top Actions */}
      <div className="flex items-center justify-between mb-4">
        <div className="flex gap-2 flex-wrap">
          {filters.map((filter) => (
            <button
              key={filter}
              onClick={() => setActiveFilter(filter)}
              className={clsx(
                "px-4 py-1.5 rounded-full text-sm border",
                activeFilter === filter
                  ? "bg-blue-600 text-white"
                  : "bg-white hover:bg-gray-100 text-gray-700 border-gray-300"
              )}
            >
              {filter}
            </button>
          ))}
        </div>
        <div className="flex gap-2">
          <input
            type="text"
            placeholder="Search ..."
            className="border border-gray-300 rounded px-3 py-1.5 text-sm"
          />
        </div>
      </div>
      {/* Document List */}
      <div className="space-y-4">
      {/* Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white rounded-lg shadow-lg w-11/12 md:w-1/2 p-6">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-semibold">Map Infrastructure Context
              </h2>
              <button
                onClick={() => {setIsModalOpen(false);setSelected(""),setStepMapTemplate(2)}}
                className="text-gray-500 hover:text-gray-700 text-2xl"
              >
                &times;
              </button>
            </div>
            <div>
              {stepMapTemplate === 1 ? 
              <div>
                <div className="space-y-4">
                  {/* Existing Template */}
                  <div
                    onClick={() => setSelected('existing')}
                    className={`cursor-pointer border rounded-md p-4 flex items-center justify-between hover:bg-gray-50 ${
                      selected === 'existing' ? 'border-blue-500 bg-blue-50' : 'border-gray-300'
                    }`}
                  >
                    <span className="text-gray-700">Existing Template</span>
                    {selected === 'existing' && <span className="text-blue-500 font-bold">✓</span>}
                  </div>
                  {/* New Template */}
                  <div
                    onClick={() => setSelected('new')}
                    className={`cursor-pointer border rounded-md p-4 flex items-center justify-between hover:bg-gray-50 ${
                      selected === 'new' ? 'border-blue-500 bg-blue-50' : 'border-gray-300'
                    }`}
                  >
                    <span className="text-gray-700">Create New Template</span>
                    {selected === 'new' && <span className="text-blue-500 font-bold">✓</span>}
                  </div>
                </div>

                {/* Confirm button */}
                <div className="mt-6 flex justify-end">
                  <button
                    className="px-5 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50"
                    disabled={!selected}
                    onClick={() => selected === 'existing' ? setStepMapTemplate(2) : mapTemplate(mapTemplateJson)}
                  >
                    Continue
                  </button>
                </div>
              </div> : <>
              
              {templateData.length > 0 ? (
  <div className="space-y-4">
    <h2 className="text-md font-semibold">Choose any one Infrastructure Context
    </h2>
    <div className="h-[250px] overflow-y-auto overflow-x-hidden space-y-2">
  {templateData.map((template) => (
    <div
      key={template._id}
      onClick={() => setSelectedTemplateId(template._id)}
      className={`cursor-pointer border rounded-md p-4 flex items-center justify-between hover:bg-gray-50 ${
        selectedTemplateId === template._id ? 'border-blue-500 bg-blue-50' : 'border-gray-300'
      }`}
    >
      <span className="text-gray-700">{template.templateName}</span>
      {selectedTemplateId === template._id && (
        <span className="text-blue-500 font-bold">✓</span>
      )}
    </div>
  ))}
    </div>
    {/* Save Button */}
    {/* <div className="mt-6 flex justify-between">
  <button
    className="px-5 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50"
    onClick={() => setStepMapTemplate(2)}
  >
    Previous
  </button>

  <button
    className="px-5 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50"
    disabled={!selectedTemplateId}
    onClick={() => {
    
      // alert(selectedTemplateId)
      // alert(JSON.stringify(mapTemplateJson.document_id))
      // console.log('Selected Template ID:', selectedTemplateId)}
         saveMapTemlate()

        
    }}
  >
    Save
  </button>
</div> */}

<div className="flex justify-end">
  <button
    className="px-5 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50"
    disabled={!selectedTemplateId}
    onClick={() => saveMapTemlate()}
  >
    Save
  </button>
</div>

  </div>
) : (
  <div className="text-center text-gray-500 text-lg mt-4">No Infrastructure Context Found</div>
)}
              
              </>}
              {console.log(templateData)}
            </div>
          </div>
        </div>
      )}
   

      {/* <p className="text-sm text-gray-500">Select a document name to view specification</p> */}
      {data.requirements_types!==undefined ? 
        data.requirements_types.map((doc, index) => (
          <div
            key={doc.document_id}
            className="bg-white shadow-sm border border-gray-200 rounded-lg p-4 flex justify-between items-start"
          >
            {/* Left: Icon + Info */}
            <div className="flex gap-3 items-start">
            
            <div className="flex-shrink-0 p-2 rounded-lg bg-slate-50">
            <div  className={`text-3xl ${doc.iconColor}`}><FileText className="h-10 w-10 text-indigo-600" /></div>
            </div>

              <div>
                {/* <a   className="text-blue-600 hover:underline cursor-pointer"
  onClick={() => handleViewRequirements(doc.document_id)}><h2 
 className="text-md font-semibold">{doc.title}</h2></a> */}


                <h2 className="text-md font-semibold">{doc.title}</h2>


                <div className="text-sm text-gray-500 flex gap-2 mt-1">
                  <span>{doc.created}</span> · 
                  <span>{doc.user.name}</span> 
                  {doc.infraContext?.templateName && (
                    <> · <span>InfrastructureContext: {doc.infraContext.templateName}</span></>
                  )}
                </div>
                 <div className="flex gap-2 mt-2 flex-wrap">
          
          <span class="inline-flex items-center px-2 py-1 text-xs font-medium border rounded bg-gray-200 text-gray-800">
          Total Requirements :  {doc.requirements.length}
          </span>

          <span class="inline-flex items-center px-2 py-1 text-xs font-medium border rounded bg-gray-200 text-gray-800">
          Total Specifications :  {doc.approved_count+doc.unapproved_count}
          </span>

          <span class="inline-flex items-center px-2 py-1 text-xs font-medium border rounded bg-green-200 text-gray-800">
          Approved :  {doc.approved_count}
          </span>

          <span class="inline-flex items-center px-2 py-1 text-xs font-medium border rounded bg-blue-200 text-gray-800">
          Un Approved :  {doc.unapproved_count}
          </span>
                </div>
              </div>

            </div>

            {/* Right: Actions */}
            <div className="relative" ref={dropdownRef}>

              
            <div className="flex gap-2">
            {/* <button
      onClick={() => handleViewTemplate(doc.document_id)}
      className="px-3 py-1 text-sm text-white bg-indigo-600 rounded hover:bg-indigo-700"
    >
      View All Template
    </button> */}
    
    {/* <button
      onClick={() => handleViewRequirements(doc.document_id)}
      className="px-3 py-1 text-sm text-white bg-indigo-600 rounded hover:bg-indigo-700"
    >
      View Input Requirements
    </button> */}


<button
  onClick={() => handleViewRequirements(doc.document_id,doc.title)}
  className="group relative flex items-center gap-1 bg-[#0a2f6c] hover:bg-[#0a2f6c]/90 text-white rounded px-2 py-1 text-xs transition-all duration-300"
>
  <Eye className="w-4 h-4" />
  <span className="relative">
    {/* Partial label with chevron */}
    <span className="inline group-hover:hidden flex items-center gap-0.5">
      Input <ChevronRight className="w-3 h-3" />
    </span>

    {/* Full label on hover */}
    <span className="hidden group-hover:inline">View Input Requirements</span>
  </span>
</button>


    {/* <button
      onClick={() => handleViewSpecifications(doc.document_id)}
      className="px-3 py-1 text-sm text-white bg-indigo-600 rounded hover:bg-indigo-700"
    >
      View Generated Specifications
    </button> */}
  

  
  <button
  onClick={() => handleViewSpecifications(doc.document_id,doc.title)}
  className="group relative flex items-center gap-1 bg-[#0a2f6c] hover:bg-[#0a2f6c]/90 text-white rounded px-2 py-1 text-xs transition-all duration-300"
>
  <Eye className="w-4 h-4" />
  <span className="relative">
    {/* Partial label with chevron */}
    <span className="inline group-hover:hidden flex items-center gap-0.5">
      Generated <ChevronRight className="w-3 h-3" />
    </span>

    {/* Full label on hover */}
    <span className="hidden group-hover:inline">View Generated Specifications</span>
  </span>
</button>

&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;


              <button onClick={() => setOpenDropdown(openDropdown === doc.document_id ? null : doc.document_id)}>
                <MoreVertical className="text-gray-500 hover:text-black" />
              </button>
              </div>
              {openDropdown === doc.document_id && (
                <div onMouseDown={(e) => e.stopPropagation()} className="absolute right-0 mt-2 w-148 bg-white border border-gray-200 rounded shadow z-50">
                  <div className="p-2 font-medium text-sm border-b">Actions</div>
                  {/* <button onClick={() => handleViewRequirements(index)} className="flex items-center gap-2 px-4 py-2 hover:bg-gray-100 text-sm w-full">
                    <Eye className="w-4 h-4" /> View Specification
                  </button> */}
                  <button className="flex items-center gap-2 px-4 py-2 hover:bg-gray-100 text-sm w-full">
                    <FileText className="w-4 h-4" /> Export
                  </button>
                  <button className="flex items-center gap-2 px-4 py-2 hover:bg-gray-100 text-orange-600 text-sm w-full">
                    <Star className="w-4 h-4" /> {doc.starred ? "Remove Star" : "Add Star"}
                  </button>
                  {/* onClick={() => mapTemplate(doc)} */}
                  <button 
                  onClick={() => {setIsModalOpen(true); setOpenDropdown(null);setMapTemplateJson(doc)}}
                  className="flex items-center gap-2 px-4 py-2 hover:bg-gray-100 text-sm w-full">
                    <LayoutPanelTop className="w-4 h-4" /> Map Infrastructure Context
                  </button>
                  <button 
                   onClick={() => {setDeleteIsModalOpen(true); setOpenDropdown(null);setMapTemplateJson(doc)}}
                  className="flex items-center gap-2 px-4 py-2 hover:bg-gray-100 text-red-600 text-sm w-full">
                    <Trash className="w-4 h-4" /> Delete
                  </button>
                </div>
              )}
            </div>
          </div>
        )) : ""}
      </div>
    </div>)
  }
     {selectedDoc && clickviewRequirement===false && dataTechSpec.length > 0 && (
      <>
      {/* Top Actions */}
      <div className="flex items-center justify-between mb-4">
        <div className="flex gap-2 flex-wrap">
          {innerfilters.map((filter) => (
            <button
              key={filter}
              onClick={() => setInnerActiveFilter(filter)}
              className={clsx(
                "d-none px-4 py-1.5 rounded-full text-sm border",
                activeInnerFilter === filter
                  ? "bg-blue-600 text-white"
                  : "bg-white hover:bg-gray-100 text-gray-700 border-gray-300"
              )}
            >
              {filter}
            </button>
          ))}
        </div>
        <div className="flex gap-2 d-none">
          <input
            type="text"
            placeholder="Search ..."
            className="border border-gray-300 rounded px-3 py-1.5 text-sm"
          />
        </div>
      </div>

  <div className="flex justify-between items-center border-b p-3  text-sm">
  {/* Left section */}
  <div className="flex items-center space-x-4">
    <div className="flex items-center space-x-1 text-blue-600 cursor-pointer" onClick={closeDetailDocumentView}>
      <svg className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M10 19l-7-7 7-7" />
      </svg>
      <span className="font-medium">Back to Infrastructure Context List</span>
    </div>
  </div>

</div>


      <div className="flex gap-4 mb-4 mt-4">
        <input
          type="text"
          placeholder="Search ..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          className="border px-3 py-2 rounded w-1/2 text-sm"
        />
        <div className="w-1/3">
          <Select
              options={requirementTypes}
              value={selectedTypes}
              onChange={setSelectedTypes}
              isClearable
              isMulti
              placeholder="Filter by Section"
          />
        </div>
        <div className="w-1/3">
          <Select
              options={status}
              value={selectedStatus}
              onChange={setSelectedStatus}
              isClearable
              isMulti
              placeholder="Filter by Status"
          />
        </div>
      </div>




      
        <div className="p-6 bg-white shadow rounded-lg lg:col-span-5">
          {/* <button
      onClick={() => closeDetailDocumentView()}
      className="absolute top-[80px] right-[5px] bg-white text-black px-2 py-2 rounded-full shadow hover:bg-gray-100 flex items-center justify-center"
      >
      <CircleX size={25} color='#000' />
    </button> */}



    

         <div className="flex justify-between items-center mb-4">
 
 
 
  <div>
    <h2 className="text-xl font-semibold">{sepcificationDocumentName}</h2>
    <p className="text-sm text-gray-500">
      {/* {selectedDoc.requirements.length} specification found in this document */}
    </p>
  </div>

<div className="flex gap-2">

<button
  onClick={refresh}
  className="group relative flex items-center gap-1 bg-[#0a2f6c] hover:bg-[#0a2f6c]/90 text-white rounded px-2 py-1 text-xs transition-all duration-300"
>
  <RefreshCw className="w-4 h-4" />
  <span className="relative">
    {/* Partial label with chevron */}
    <span className="inline group-hover:hidden flex items-center gap-0.5">
      Refresh
    </span>
    {/* Full label on hover */}
    <span className="hidden group-hover:inline"> Refresh</span>
  </span>
</button>

  Approve All Specifications
         <div className="flex items-center space-x-3">
      <span className="text-sm font-medium text-gray-700">
        {/* {enabled ? 'ON' : 'OFF'} */}
      </span>

      <button
        onClick={() => setEnabled(!enabled)}
        className={`w-12 h-6 flex items-center rounded-full p-1 duration-300 ease-in-out 
          ${enabled ? 'bg-green-500' : 'bg-gray-300'}`}
      >
        <div
          className={`bg-white w-4 h-4 rounded-full shadow-md transform duration-300 ease-in-out
            ${enabled ? 'translate-x-6' : 'translate-x-0'}`}
        />
      </button>
    </div>
  </div>
</div>


          <table className="w-full text-sm text-left">
            <thead className="bg-gray-100">
              <tr>
                <th className="p-3 font-medium text-gray-600">Specification
                ID</th>
                <th className="p-3 font-medium text-gray-600">Requirement
                ID</th>
                <th className="p-3 font-medium text-gray-600">Requirement
                Type</th>
                <th className="p-3 font-medium text-gray-600">Requirement
                </th>
                <th className="p-3 font-medium text-gray-600">Status
                </th>
                <th className="p-3 font-medium text-gray-600">Approved Status
                </th>
              </tr>
            </thead>
            <tbody>
              {
                clickviewRequirement===false && (
              filteredRequirements.map((req,index) => (
              <React.Fragment key={index}>
                <tr className="border-b hover:bg-gray-50">
                  <td
                    className="p-3 cursor-pointer text-blue-600 hover:underline flex items-center gap-2"
                    onClick={() => toggleRow(index)}
                  >
                    {expandedRows.includes(index) ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
                    {req.serviceSpecId}
                  </td>

                  <td className="p-3">
                      {req.reqId}
                    </td>
                  <td className="p-3">{req.requirementType}</td>
                  <td className="p-3 truncate max-w-xs">{req.description}</td>
                  <td className="p-3">{req.techSpecStatus}</td>
                  <td className="p-3">{req.techSpecApprovalStatus}</td>
                </tr>
                {/* { //expandedRows.includes(index) && (  */}
                  <tr className={expandedRows.includes(index) ? "bg-gray-50" : "bg-gray-50 d-none"}>
                    <td colSpan={6} className="p-3 text-gray-800">
                      <strong>Requirement:</strong> {req.description}
                       <br/> 
                      <div>

  <div class="space-y-4">
     {
     req.allSpecs !== undefined ?  
     req.allSpecs.map((reqinner,innerindex) => (
<>
<div class="flex items-center justify-between bg-white border rounded p-3">
      <div class="w-full">
      <table className="min-w-full border border-gray-200 rounded-lg shadow-sm text-sm text-left">
  <thead className="bg-gray-100 text-gray-700">
    <tr>
      <th className="px-4 py-2 border-b">Specification</th>
      <th className="px-4 py-2 border-b">Score</th>
      <th className="px-4 py-2 border-b">Approved</th>
      <th className="px-4 py-2 border-b">Edit</th>
    </tr>
  </thead>
  <tbody>
    <tr className="bg-white hover:bg-gray-50 border-t">
      <td className="px-4 py-3 align-top text-sm text-gray-800">
  {req.requirementType === "Technical Requirements" || req.requirementType === "technicalRequirements" ? (
    <ul className="list-disc pl-5 space-y-1">
      {(specEdits[`${index}_${innerindex}`] ?? reqinner.specification).map((item, idx) => (
        <li key={idx}>{item}</li>
      ))}
    </ul>
  ) : (
    <p
      className="whitespace-pre-line"
      dangerouslySetInnerHTML={{
        __html:
          specEdits[`${index}_${innerindex}`] ??
          `${reqinner.IAMRoleName}<br/>${reqinner.permissions}<br/>${reqinner.scope}`,
      }}
    ></p>
  )}
</td>

      <td className="px-4 py-3 align-top text-gray-800">
        <span>{reqinner.confidence}</span>
      </td>
      <td className="px-4 py-3 align-top text-gray-800">
        {/* Radio Button */}
        <button className="bg-gray-100 rounded-full p-1 border">
          <label>
            <input
              type="radio"
              name={`radioGroup${index}`}
              value={1}
              checked={selectedOptions[req.requirementId] === reqinner.specId}
              onChange={() => setSelectedOption(reqinner.specId, req.requirementId)}
              className="appearance-none w-5 h-5 border border-gray-400 rounded-full checked:bg-green-500 checked:border-green-500"
            />
          </label>
        </button>
</td>
<td className="px-4 py-3 align-top text-gray-800">
        {/* Edit Button */}
        <button
          className="bg-gray-100 rounded-full p-1 border hover:bg-gray-200"
          onClick={() => showTextArea(index + "_" + innerindex)}
        >
          <ClipboardPen />
        </button>
      </td>
    </tr>
  </tbody>
</table>

        {/* <p class="text-sm font-medium text-gray-800 mb-1"
        
        dangerouslySetInnerHTML={{
          __html: req.requirementType === "Technical Requirements" || req.requirementType === "technicalRequirements" 
            ? (specEdits[`${index}_${innerindex}`] ?? reqinner.specification)
            : (specEdits[`${index}_${innerindex}`] ?? `${reqinner.IAMRoleName}<br/>${reqinner.permissions}<br/>${reqinner.scope}`)
        }}
        >
        </p> */}
      </div>
      {/* <div class="flex items-center gap-2 ml-4">
        <span>{reqinner.confidence}</span>
        <button class="bg-gray-100 rounded-full p-1 border">
       {
          <label key="1" className="">
            <input
              type="radio"
              name={"radioGroup"+index}
              value={1}
              //checked={reqinner.approved===true ? true :false}
              //checked={selectedOptions[req.requirementId] === reqinner.specId}
              checked={selectedOptions[req.requirementId] === reqinner.specId}
              onChange={(e) => setSelectedOption(reqinner.specId,req.requirementId)}
              className="appearance-none w-5 h-5 border border-gray-400 rounded-full checked:bg-green-500 checked:border-bg-green-500"
            />
            <span className="text-gray-800"></span>
          </label>

       }
        </button>
        <button class="bg-gray-100 rounded-full p-1 border"
        onClick={() => {
          showTextArea(index+"_"+innerindex)
        }}
        >
          <ClipboardPen />
          </button>
      </div> */}
    </div>

<div id={index+"_"+innerindex} className="d-none flex items-center justify-between bg-white border rounded p-3">
<textarea
  id={`textarea_${index}_${innerindex}`}
  rows={3}
  value={
    req.requirementType === "Technical Requirements" || req.requirementType === "technicalRequirements"
      ? (specEdits[`${index}_${innerindex}`] ?? reqinner.specification).join('\n') // Array to newline-separated string
      : specEdits[`${index}_${innerindex}`] ?? `${reqinner.IAMRoleName}\n${reqinner.permissions}\n${reqinner.scope}`
  }
  onChange={(e) =>
    setSpecEdits((prev) => ({
      ...prev,
      [`${index}_${innerindex}`]:
        req.requirementType === "Technical Requirements" || req.requirementType === "technicalRequirements"
          ? e.target.value.split('\n') // Convert back to array for technical
          : e.target.value,
    }))
  }
  className="w-full border border-gray-300 rounded-lg p-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none"
/>



<div className="mt-4 flex justify-end gap-2">
&nbsp;&nbsp;
  <button
   onClick={() => {
    closeTextArea(index+"_"+innerindex)
  }}
    className="px-4 py-2 text-sm rounded border border-gray-300 hover:bg-gray-100 text-gray-700"
  >
    Cancel
  </button>
    &nbsp;&nbsp;
  <button
  onClick={() => {

    let textareaValue = $('#textarea_' + `${index}_${innerindex}`).val();

    // Convert string to array by splitting on newlines
    let specArray = textareaValue.split('\n').filter(line => line.trim() !== '');

    // Assign to specification array
    req.allSpecs[innerindex]['specification'] = specArray;


    if(req.requirementType!=="Technical Requirements" && req.requirementType!=="technicalRequirements"){
      return;
    }

    let obj = {
        requirement:req.requirementType,
        allSpecs: req.allSpecs,
    }
    //console.log(`${API_SERVER_URL}tech-spec/document/`+selectedDocumentId+`/requirement/`+req.requirementId+"/")

    try {
      const result =  apiCall("PUT", `${API_SERVER_URL}tech-spec/document/`+selectedDocumentId+`/requirement/`+req.requirementId+"/",obj);
      if (result.code === API_SUCCESS_RESPONSE_CODE) {
      }
    } catch (error) {
      console.error("Error fetching contracts", error);
    }

    // console.log("***************")
    // console.log(obj)
    // console.log("***************")

    // const updatedText = specEdits[`${index}_${innerindex}`] ?? req.description;
    // const selectedRadio = radioSelections[index];

    // console.log("Save clicked for:", {
    //   specification: req.specification,
    //   text: updatedText,
    //   selectedRadio,
    // });

    closeTextArea(`${index}_${innerindex}`);

  }}
  className="px-4 py-2 text-sm rounded bg-blue-600 text-white hover:bg-blue-700"
>
  Save
</button>


</div>
</div>
</>
)) : ""}
  </div>

</div>


                      
                    </td>
                  </tr>
              {/* //  )} */}
              </React.Fragment>
            )))}
          {
            filteredRequirements.length===0 ? 
            <tr><td colSpan={5} className='text-center'>No Record Found</td></tr> : ""
          }

            </tbody>
          </table>
        </div>
        </>
      )} 

          </div>
        }
        </main>
      </div>
    </div>
  );
};

